// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"AwsSettingsList_contentComponent__3bWFR","tableContainer":"AwsSettingsList_tableContainer__1NrXE","root":"AwsSettingsList_root__3IA5U"};